import { makeAutoObservable, runInAction } from 'mobx';
import { PaymentServiceWithVersionsResponseType } from '../api/types/payments/payment-template';
import appApi from '../api/app-api';

class GlobalPaymentServices {
  services: PaymentServiceWithVersionsResponseType[] = [];
  constructor() {
    makeAutoObservable(this);
  }

  async fetchPaymentService() {
    // Reload all payment services and update the state
    const allServices = await appApi.getAllPaymentServices();
    globalPaymentServices.services = allServices.data.body;
  }
}
const globalPaymentServices = new GlobalPaymentServices();
export default globalPaymentServices;
